var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 128.704,
    viewBox: "0 0 182 128.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Blue_image",
    "data-name": "Blue image",
    transform: "translate(-725 -526.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    d: "M122.911,30c-11.668-.4-22.78-4.172-33.391-8.293S68.4,13.025,57.01,10.842c-7.325-1.4-15.7-1.6-21.6,2.318-5.681,3.786-7.516,10.3-8.5,16.355-.743,4.554-1.179,9.347.855,13.611,1.413,2.96,3.919,5.448,5.654,8.284,6.034,9.865,1.769,22.03-4.768,31.662-3.065,4.518-6.625,8.834-8.992,13.638s-3.461,10.328-1.39,15.243c2.052,4.868,6.943,8.516,12.241,11.085,10.761,5.219,23.436,6.712,35.805,7.559,27.372,1.871,54.888,1.062,82.332.249,10.157-.3,20.357-.6,30.348-2.174,5.549-.873,11.276-2.257,15.306-5.6a12.816,12.816,0,0,0,2.953-16.743c-5.747-8.924-21.634-11.139-25.656-20.714-2.21-5.271.059-11.141,3.274-16.029C181.76,59.1,193.314,49.9,193.921,37.916c.418-8.232-5.136-16.476-13.725-20.372-9-4.083-21.486-3.57-28.124,3.189C145.231,27.686,133.214,30.363,122.911,30Z",
    transform: "translate(707.833 516.375)",
    fill: "#2699fb",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "undraw_Select_re_3kbd",
    transform: "translate(751.785 558.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3771",
    "data-name": "Path 3771",
    d: "M577.481,108.229h-.527V93.784a8.36,8.36,0,0,0-8.36-8.36h-30.6a8.36,8.36,0,0,0-8.36,8.36v79.243a8.36,8.36,0,0,0,8.36,8.36h30.6a8.36,8.36,0,0,0,8.36-8.36V118.511h.527Z",
    transform: "translate(-474.695 -85.424)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3772",
    "data-name": "Path 3772",
    d: "M590.363,108.162v79.127a6.243,6.243,0,0,1-6.243,6.243H553.37a6.244,6.244,0,0,1-6.243-6.243V108.162a6.244,6.244,0,0,1,6.243-6.243h3.73A2.968,2.968,0,0,0,559.847,106h17.532a2.968,2.968,0,0,0,2.747-4.086h3.994a6.244,6.244,0,0,1,6.244,6.243Z",
    transform: "translate(-489.884 -99.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773",
    "data-name": "Path 3773",
    d: "M245.253,581.861a.991.991,0,0,1-.651-.243l-1.466-1.279a.991.991,0,0,1-.1-1.4L253.7,566.718a.779.779,0,0,1,.068-.071.988.988,0,0,1,1.327-.024l1.467,1.279a.988.988,0,0,1,.336.678h0a.988.988,0,0,1-.242.717L246,581.523A.989.989,0,0,1,245.253,581.861Z",
    transform: "translate(-225.682 -502.962)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3774",
    "data-name": "Path 3774",
    d: "M397.574,513.99a1.026,1.026,0,0,1-.3-.046.986.986,0,0,1-.578-.489l-.891-1.73a.985.985,0,0,1,.225-1.194.938.938,0,0,1,.2-.138l14.418-7.433a.991.991,0,0,1,1.332.425l.891,1.73a.991.991,0,0,1-.425,1.332l-14.417,7.433A.982.982,0,0,1,397.574,513.99Z",
    transform: "translate(-358.415 -447.809)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3775",
    "data-name": "Path 3775",
    d: "M395.725,537.617a1,1,0,0,1-.887-.547l-.873-1.739a.985.985,0,0,1-.076-.68c0-.017.01-.037.015-.055l.005-.017c.015-.045.031-.11.048-.185l.01-.044a1.669,1.669,0,0,1,.306-.773.291.291,0,0,1,.067-.047l6.33-3.837a.988.988,0,0,1,1.337.434l1.6,3.294a.99.99,0,0,1-.441,1.326l-7.009,2.767a.949.949,0,0,1-.43.1Z",
    transform: "translate(-356.826 -471.017)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_997",
    "data-name": "Ellipse 997",
    cx: 7.057,
    cy: 7.057,
    r: 7.057,
    transform: "translate(27.102 43.356)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3776",
    "data-name": "Path 3776",
    d: "M339.3,692.547h-1.946a.99.99,0,0,1-.989-.989V675.074a.99.99,0,0,1,.989-.989H339.3a.963.963,0,0,1,.358.068.981.981,0,0,1,.628.875.259.259,0,0,1,0,.046v16.484A.99.99,0,0,1,339.3,692.547Z",
    transform: "translate(-306.911 -596.466)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777",
    "data-name": "Path 3777",
    d: "M369.5,680.263q-.014-.023-.03-.045a.917.917,0,0,0-.1-.178L366.05,675.4l-2.733-3.823h-4.662l.33.46.587.821,1.818,2.542,3.9,5.45-3.612,7.255c-.148.3.1.72.559.947l1.742.868a1.279,1.279,0,0,0,.558.14.566.566,0,0,0,.535-.264l4.49-9.019A.523.523,0,0,0,369.5,680.263Z",
    transform: "translate(-326.262 -594.287)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3778",
    "data-name": "Path 3778",
    d: "M296.68,562.672a.991.991,0,0,1-.69-.284l-2.641-2.533a.979.979,0,0,1-.285-.565.857.857,0,0,1-.011-.134.9.9,0,0,1,.012-.152.973.973,0,0,1,.274-.549l5.616-4.855c.152-.157.538-.124.879-.1l.051,0a1.842,1.842,0,0,0,.189.011c.023,0,.05,0,.075,0a1,1,0,0,1,.628.283l1.386,1.366a.99.99,0,0,1,.01,1.4l-4.777,5.8a.986.986,0,0,1-.715.3Z",
    transform: "translate(-269.312 -491.763)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779",
    "data-name": "Path 3779",
    d: "M369.883,460.032l-.007-.264a2.181,2.181,0,0,0,1.248-.282.811.811,0,0,0,.314-.6.464.464,0,0,0-.152-.382.8.8,0,0,0-.816-.007l-.218.1.418-3.058.261.036-.356,2.6a.931.931,0,0,1,.881.127.721.721,0,0,1,.245.592,1.072,1.072,0,0,1-.422.8A2.427,2.427,0,0,1,369.883,460.032Z",
    transform: "translate(-336.005 -406.739)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2810",
    "data-name": "Rectangle 2810",
    width: 1.42,
    height: 0.264,
    transform: "translate(36.219 49.063)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2811",
    "data-name": "Rectangle 2811",
    width: 1.42,
    height: 0.264,
    transform: "translate(31.736 49.063)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3780",
    "data-name": "Path 3780",
    d: "M332.517,553.492H319.991c-.481,0-.857-.772-.857-1.757V539.383a7.124,7.124,0,0,1,4.974-6.79,1.235,1.235,0,0,1-.029-.264,1.254,1.254,0,0,1,1.253-1.253h1.846a1.254,1.254,0,0,1,1.253,1.253,1.236,1.236,0,0,1-.029.265,7.074,7.074,0,0,1,1.953.967c.123.086.244.177.36.272a7.1,7.1,0,0,1,2.245,3.149c.073.2.137.409.192.619h0a7.17,7.17,0,0,1,.225,1.783v12.351c0,.961-.363,1.727-.829,1.754A.1.1,0,0,1,332.517,553.492Z",
    transform: "translate(-291.953 -472.313)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3781",
    "data-name": "Path 3781",
    d: "M329,697.746h-5.011a.858.858,0,0,1-.857-.857v-3.956a.858.858,0,0,1,.857-.857H329a.858.858,0,0,1,.857.857v3.956A.858.858,0,0,1,329,697.746Z",
    transform: "translate(-295.426 -612.084)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3782",
    "data-name": "Path 3782",
    d: "M376.335,688.565a.859.859,0,0,1-.8-.558l-1.378-3.708a.858.858,0,0,1,.5-1.1l4.7-1.745a.858.858,0,0,1,1.1.5l1.378,3.708a.858.858,0,0,1-.5,1.1l-4.7,1.745A.853.853,0,0,1,376.335,688.565Z",
    transform: "translate(-339.671 -602.814)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3783",
    "data-name": "Path 3783",
    d: "M315.876,383.815c1.308-.756,2.894-.176,4.245.141a6.305,6.305,0,0,0,4.33-.272,3.821,3.821,0,0,0,2.139-2.979,2.926,2.926,0,0,0-1.723-2.936,2.41,2.41,0,0,0-3.079,1.34l.362-.047c-1.4-1.837-3.124-3.732-5.53-4.09a4.486,4.486,0,0,0-3.155.6,4.647,4.647,0,0,0-1.75,2.442,13.392,13.392,0,0,0-.55,3.515c-.015.254.381.253.4,0,.108-1.854.284-4.091,1.8-5.386a3.881,3.881,0,0,1,2.852-.825,5.817,5.817,0,0,1,2.943,1.165,13.361,13.361,0,0,1,2.652,2.776.2.2,0,0,0,.362-.047,2.015,2.015,0,0,1,2.474-1.106,2.516,2.516,0,0,1,1.55,2.6,3.464,3.464,0,0,1-2.1,2.712,6.169,6.169,0,0,1-4.037.119c-1.418-.342-3.019-.849-4.383-.061a.2.2,0,0,0,.2.342Z",
    transform: "translate(-285.035 -336.74)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3784",
    "data-name": "Path 3784",
    d: "M579.127,157.575a4.219,4.219,0,1,0,0,8.439h0a4.219,4.219,0,1,0,0-8.439Z",
    transform: "translate(-514.001 -148.062)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3785",
    "data-name": "Path 3785",
    d: "M686.453,202.685H664.3a1.055,1.055,0,1,1,0-2.11h22.152a1.055,1.055,0,1,1,0,2.11Z",
    transform: "translate(-590.692 -185.392)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3786",
    "data-name": "Path 3786",
    d: "M671.289,168.685H664.3a1.055,1.055,0,1,1,0-2.11h6.988a1.055,1.055,0,1,1,0,2.11Z",
    transform: "translate(-590.692 -155.875)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3787",
    "data-name": "Path 3787",
    d: "M579.127,291.575a4.219,4.219,0,1,0,0,8.439h0a4.219,4.219,0,1,0,0-8.439Z",
    transform: "translate(-514.001 -264.393)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3788",
    "data-name": "Path 3788",
    d: "M686.453,336.685H664.3a1.055,1.055,0,0,1,0-2.11h22.152a1.055,1.055,0,0,1,0,2.11Z",
    transform: "translate(-590.692 -301.723)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3789",
    "data-name": "Path 3789",
    d: "M671.289,302.685H664.3a1.055,1.055,0,0,1,0-2.11h6.988a1.055,1.055,0,1,1,0,2.11Z",
    transform: "translate(-590.692 -272.206)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3790",
    "data-name": "Path 3790",
    d: "M579.127,559.576a4.219,4.219,0,1,0,0,8.439h0a4.219,4.219,0,1,0,0-8.439Z",
    transform: "translate(-514.001 -497.055)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3791",
    "data-name": "Path 3791",
    d: "M686.453,604.685H664.3a1.055,1.055,0,0,1,0-2.11h22.152a1.055,1.055,0,0,1,0,2.11Z",
    transform: "translate(-590.692 -534.385)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3792",
    "data-name": "Path 3792",
    d: "M671.289,570.685H664.3a1.055,1.055,0,0,1,0-2.11h6.988a1.055,1.055,0,0,1,0,2.11Z",
    transform: "translate(-590.692 -504.868)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3793",
    "data-name": "Path 3793",
    d: "M579.127,693.576a4.219,4.219,0,1,0,0,8.439h0a4.219,4.219,0,1,0,0-8.439Z",
    transform: "translate(-514.001 -613.386)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3794",
    "data-name": "Path 3794",
    d: "M686.453,738.685H664.3a1.055,1.055,0,0,1,0-2.11h22.152a1.055,1.055,0,0,1,0,2.11Z",
    transform: "translate(-590.692 -650.716)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3795",
    "data-name": "Path 3795",
    d: "M671.289,704.685H664.3a1.055,1.055,0,0,1,0-2.11h6.988a1.055,1.055,0,0,1,0,2.11Z",
    transform: "translate(-590.692 -621.199)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3796",
    "data-name": "Path 3796",
    d: "M554.65,398.277h-50.9a2.178,2.178,0,0,1-2.176-2.176v-16.35a2.178,2.178,0,0,1,2.176-2.176h50.9a2.178,2.178,0,0,1,2.176,2.176V396.1A2.178,2.178,0,0,1,554.65,398.277Z",
    transform: "translate(-450.34 -339.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    "data-name": "Path 3797",
    d: "M579.127,424.076a4.219,4.219,0,1,0,0,8.439h0a4.219,4.219,0,1,0,0-8.439Z",
    transform: "translate(-514.001 -379.422)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3798",
    "data-name": "Path 3798",
    d: "M686.453,469.186H664.3a1.055,1.055,0,0,1,0-2.11h22.152a1.055,1.055,0,0,1,0,2.11Z",
    transform: "translate(-590.692 -416.752)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    d: "M671.289,435.186H664.3a1.055,1.055,0,0,1,0-2.11h6.988a1.055,1.055,0,0,1,0,2.11Z",
    transform: "translate(-590.692 -387.235)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3800",
    "data-name": "Path 3800",
    d: "M554.65,398.277h-50.9a2.178,2.178,0,0,1-2.176-2.176v-16.35a2.178,2.178,0,0,1,2.176-2.176h50.9a2.178,2.178,0,0,1,2.176,2.176V396.1A2.178,2.178,0,0,1,554.65,398.277Zm-50.9-20.57a2.046,2.046,0,0,0-2.044,2.044V396.1a2.046,2.046,0,0,0,2.044,2.044h50.9a2.046,2.046,0,0,0,2.044-2.044v-16.35a2.046,2.046,0,0,0-2.044-2.044Z",
    transform: "translate(-450.34 -339.053)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M592.837,444.642a.512.512,0,0,1-.308-.1l-.005,0-1.16-.888a.516.516,0,0,1,.628-.818l.752.576,1.776-2.317a.515.515,0,0,1,.723-.1h0l-.011.015.011-.015a.516.516,0,0,1,.1.723l-2.089,2.724a.516.516,0,0,1-.41.2Z",
    transform: "translate(-528.112 -394.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    d: "M241.3,812.839H113.132a.132.132,0,0,1,0-.264H241.3a.132.132,0,0,1,0,.264Z",
    transform: "translate(-113 -716.695)",
    fill: "#ccc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoApplication);
export default __webpack_public_path__ + "static/media/no-application.7e8338e371e897d603fcfc7444eda32c.svg";
export { ForwardRef as ReactComponent };